// @ts-nocheck
import type {
  SankeyGraph,
  SankeyGraphVisits,
  PeopleEngagedResponse,
  PresetQuestion,
  WhatsAppDetails,
} from 'src/types/chatbot';

import type {
  ChatbotActions,
  ExternalChatbotVariable,
  DiscoverJobAttribute,
} from 'src/action-creators/chatbot';

import {
  SANKEY_DATA,
  SANKEY_VISITS_DATA,
  PEOPLE_ENGAGED_DATA,
  PEOPLE_ENGAGED_LOADING_DATA,
  SANKEY_GRAPH_LOADING_DATA,
  RECEIVE_QUESTION_SIMILARITY,
  RECEIVE_PRESET_QUESTIONS,
  RECEIVE_T2A_KEYWORDS,
  RECEIVE_EXTERNAL_VARS,
  SET_WHATSAPP_DETAILS,
  SET_FLOW_DETAILS,
  RECEIVE_DISCOVER_JOB_ATTRIBUTES,
  RECEIVE_TEMPLATE_PHONE_NUMBERS,
} from 'src/action-creators/chatbot';


export type State = {
  sankeyGraph: SankeyGraph[];
  sankeyGraphVisits: SankeyGraphVisits[];
  peopleEngaged: PeopleEngagedResponse[];
  isPeopleEngagedLoading: boolean;
  isSankeyGraphLoading: boolean;
  questionSimilarity: {
    [key: string]: string[];
  };
  presetQuestions: PresetQuestion[];
  t2aKeywords: {
    [key: string]: number[];
  };
  externalVariables: ExternalChatbotVariable[];
  whatsappDetails: WhatsAppDetails;
  discoverJobAttributes: DiscoverJobAttribute[];
  templatePhoneNumbers: string[];
};

export const initialState = {
  sankeyGraph: [],
  sankeyGraphVisits: [],
  peopleEngaged: [],
  isPeopleEngagedLoading: false,
  isSankeyGraphLoading: false,
  questionSimilarity: {},
  presetQuestions: [],
  t2aKeywords: {},
  externalVariables: [],
  whatsappDetails: {
    id: null,
    enable_whatsapp: false,
    whatsapp_config_enabled: false,
    whatsapp_t2a_keywords: [{keywords: [], phone_number: ''}],
    additional_config_json: {
      whatsapp_template_id: null,
      whatsapp_template_message: '',
      whatsapp_fields: {},
    },
  },
  discoverJobAttributes: [],
  templatePhoneNumbers: [],
} as const;

export default (state: State = initialState, action: ChatbotActions): State => {
  switch (action.type) {
    case SANKEY_DATA:
      return {
        ...state,
        sankeyGraph: action.payload,
      };
    case SANKEY_VISITS_DATA:
      return {
        ...state,
        sankeyGraphVisits: action.payload,
      };
    case PEOPLE_ENGAGED_DATA:
      return {
        ...state,
        peopleEngaged: action.payload,
      };
    case PEOPLE_ENGAGED_LOADING_DATA:
      return {
        ...state,
        isPeopleEngagedLoading: action.payload,
      };
    case SANKEY_GRAPH_LOADING_DATA:
      return {
        ...state,
        isSankeyGraphLoading: action.payload,
      };
    case RECEIVE_QUESTION_SIMILARITY:
      return {
        ...state,
        questionSimilarity: {...state.questionSimilarity, ...action.payload},
      };
    case RECEIVE_EXTERNAL_VARS:
      return {
        ...state,
        externalVariables: action.payload,
      };
    case RECEIVE_DISCOVER_JOB_ATTRIBUTES:
      return {
        ...state,
        discoverJobAttributes: action.payload,
      };
    case RECEIVE_TEMPLATE_PHONE_NUMBERS:
      return {
        ...state,
        templatePhoneNumbers: action.payload,
      };
    case RECEIVE_PRESET_QUESTIONS:
      return {
        ...state,
        presetQuestions: action.payload,
      };
    case RECEIVE_T2A_KEYWORDS:
      return {
        ...state,
        t2aKeywords: action.payload,
      };
    case SET_WHATSAPP_DETAILS:
      return {
        ...state,
        whatsappDetails: action.payload,
      };
    case SET_FLOW_DETAILS:
      return {
        ...state,
        flowDetails: action.payload,
      };
  }
  return state;
};
